export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export enum DrawColor {
  BLACK = 'rgb(0,0,0)',
  PURPLE = "rgb(136,71,227)",
  RED = "#ff0000"
}

export class GeometryHelper {
  /**
   * @return the smallest rectangle that cross both x and y coordinates
   */
  public static findRectAt<T extends Rect>(rects: T[], x: number, y: number): T | null {
    const matches = rects.filter(rect =>
      x >= rect.x && x <= rect.x + rect.width &&
      y >= rect.y && y <= rect.y + rect.height
    );

    if (matches.length === 0) {
      return null;
    }

    // pick the smallest area rect
    return matches.reduce((smallest: T | null, rect: T) => {
      if (!smallest) {
        return rect;
      }
      const smallestArea = smallest.width * smallest.height;
      const rectArea = rect.width * rect.height;
      return rectArea < smallestArea ? rect : smallest;
    }, null);
  }

  public static drawRectangle(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    options: { color?: DrawColor; hatched?: boolean } = {}
  ) {
    const { color = DrawColor.BLACK, hatched = false } = options;

    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = color;
    ctx.rect(x, y, width, height);
    ctx.stroke();

    if (hatched) {
      const pattern = this.getHatchedFillStyle(ctx, color)
      if (pattern) {
        ctx.fillStyle = pattern;
        ctx.fillRect(x, y, width, height);
      }
    }

    ctx.restore();
  }

  private static getHatchedFillStyle(ctx: CanvasRenderingContext2D, color: DrawColor): CanvasPattern | null {
    // Create hatched fill
    const patternCanvas = document.createElement('canvas');
    const pctx = patternCanvas.getContext('2d')!;
    patternCanvas.width = 10;
    patternCanvas.height = 10;

    pctx.strokeStyle = color;
    pctx.lineWidth = 1;
    pctx.beginPath();
    pctx.moveTo(0, 10);
    pctx.lineTo(10, 0);
    pctx.stroke();

    return ctx.createPattern(patternCanvas, 'repeat');
  }
}
